import HomePage from "@/tarot_box/pages/home/HomePage.vue"
import SearchPage from "@/tarot_box/pages/search/SearchPage.vue"
import InputPage from "@/tarot_box/pages/box_input_v2/InputPage.vue";
import OutputPage from "@/tarot_box/pages/box_result_v2/OutputPage.vue";

export const TarotBoxRoutes = [
    { path: "/", redirect: "/tarot_box/home?is_web=true"},
    { path: "/tarot_box/update", component: () => import('./pages/UpdatePage.vue') },
    { path: "/tarot_box/home", component: HomePage },
    { path: "/tarot_box/home/search", component: SearchPage },
    { path: "/tarot_box/mytarot", component: () => import('./pages/my_tarot_v2/MyTarotPageV2.vue')  },
    { path: "/tarot_box/mytarot_v2", component: () => import('./pages/my_tarot/MyTarotPage.vue')  },



    { path: "/tarot_box/notice", component: () => import('./pages/notice/NoticePage.vue') },
    { path: "/tarot_box/input/:boxId/:language?", component: () => import('./pages/box_input/InputPageTemplate.vue') },
    { path: "/tarot_box/input_v2/:boxId/:language?", component: InputPage},
    { path: "/tarot_box/result/:boxId/:language?", component: () => import('./pages/box_result/OutputPageTemplate2.vue') },
    { path: "/tarot_box/today_tarot", component: () => import('./pages/today_fortune/TodayFortune.vue') },

    //for the test
    { path: "/tarot_box/result/:boxId/:language?", component: () => import('./pages/box_result/OutputPageTemplate2.vue') },
    { path: "/tarot_box/result_v2/:boxId/:language?", component: OutputPage},

    { path: "/tarot_box/review_v2/:boxId", component: () => import('./pages/box_result/WriteReviewPage.vue'), meta: { fromPath: '' } },
    { path: "/tarot_box/review/:boxId", component: () => import('./pages/box_result/WriteReviewPageV2.vue'), meta: { fromPath: '' } },
    { path: "/tarot_box/review_complete", component: () => import('./pages/box_result/WriteReviewCompletePage.vue'), meta: { fromPath: '' }  },
    { path: "/tarot_box/review_complete_v2", component: () => import('./pages/box_result/WriteReviewCompletePageV2.vue'), meta: { fromPath: '' }  },
    { path: "/new_result/:boxId", redirect: to => { return `/tarot_box/result/${to.params.boxId}`;} },
    { path: "/tarot_box/checkout/:boxId", component: () => import('./pages/web_checkout/pages/WebCheckoutPage.vue')},
    { path: "/tarot_box/purchase_complete", component: () => import('./pages/web_checkout/pages/WebCheckoutCompletePage.vue')},


    //referral event

    { path: "/tarot_box/event/referral/:campaignId", component: () => import('@/tarot_box/pages/event_page/referral/ReferralMain.vue')},
    { path: "/tarot_box/event/invite/:campaignId", component: () => import('@/tarot_box/pages/event_page/referral/RefereePage.vue')},


    // { path: "/tarot_box/event", component: () => import('./pages/event_page/EventPage.vue')},
    { path: "/tarot_box/event2", component: () => import('./pages/event_page/EventPage2.vue')},
    { path: "/tarot_box/event3", component: () => import('./pages/event_page/EventPage3.vue')},
    { path: "/tarot_box/event4", component: () => import('./pages/event_page/EventPage4.vue')},
    { path: "/tarot_box/event5", component: () => import('./pages/event_page/EventPage5.vue')},
    { path: "/tarot_box/event6", component: () => import('./pages/event_page/EventPage6.vue')},
    { path: "/tarot_box/labs/240703", component: () => import('./pages/labs/pages/BridgePage.vue')},

    //전화타로
    { path: "/tarot_box/call", component: () => import('./pages/event_page/phone_tarot/AppMainPage.vue')},
    { path: "/tarot_box/call/home", component: () => import('./pages/event_page/phone_tarot/MainPage.vue')},
    { path: "/tarot_box/call/result", component: () => import('./pages/event_page/phone_tarot/ResultPage.vue')},
    { path: "/tarot_box/call/purchase_callback", component: () => import('./pages/event_page/phone_tarot/PurchaseCallbackPage.vue')},
    { path: "/tarot_box/call/input", component: () => import('./pages/event_page/phone_tarot/TarotCallInput.vue')},
    { path: "/tarot_box/call/saju", component: () => import('./pages/event_page/phone_tarot/SajuMainPage.vue')},


    // { path: "/us", component: () => import('../../src/test/AmericaPage.vue')},
    // { path: "/mason", component: () => import('../../src/mason/MasonMainPage.vue')},

    { path: "/signin", component: () => import('../../src/sign_in/SignInPage.vue')},
    { path: "/mypage_v1", component: () => import('../../src/my_page/MyPageV2.vue')},
    { path: "/mysaju", component: () => import('../../src/my_page/components/MySajuPage.vue')},
    { path: "/mysaju/create", component: () => import('../../src/my_page/components/MySajuCreatePage.vue')},
    { path: "/mysaju/edit", component: () => import('../../src/my_page/components/MySajuEditPage.vue'), props: true},

    { path: "/paywall", component: () => import('../../src/paywall/CloverPaywall.vue')},
    { path: "/subpaywall", component: () => import('../../src/paywall/MateChatSubscriptionPaywall.vue')},

    { path: "/tarot_box/event/:pageId", component: () => import('./pages/event_page/DynamicEventPage.vue')},

    // { path: "/tarot_box/mytarot", component: MyTarotPage },
    // { path: "/tarot_box/input/:boxId/:language?", component: InputPageTemplate },
    // { path: "/tarot_box/input_v2/:boxId/:language?", component: InputPage},
    // { path: "/tarot_box/result/:boxId/:language?", component: OutputPageTemplate },
    // { path: "/tarot_box/today_tarot", component: TodayFortune },
    //for the test
    // { path: "/tarot_box/result/:boxId/:language?", component: OutputPageTemplate2},
    // { path: "/tarot_box/result_v2/:boxId/:language?", component: OutputPage},
    //
    //
    // { path: "/tarot_box/review/:boxId", component: WriteReviewPage, meta: { fromPath: '' } },
    // { path: "/tarot_box/review_complete", component: WriteReviewCompletePage, meta: { fromPath: '' }  },
    // { path: "/new_result/:boxId", redirect: to => {
    //         return `/tarot_box/result/${to.params.boxId}`;}
    // },
    // { path: "/tarot_box/checkout/:boxId", component: WebCheckoutPage},
    // { path: "/tarot_box/purchase_complete", component: WebCheckoutCompletePage},
    //
    // //TEMP
    // { path: "/tarot_box/event", component: EventPage},
    // { path: "/tarot_box/event2", component: EventPage2},
    // { path: "/tarot_box/labs/240703", component: BridgePage},
    // { path: "/us", component: AmericaPage},
    //
    // { path: "/mason", component: MasonMainPage},
    // { path: "/signin", component: SignInPage},
    // { path: "/mypage_v1", component: MyPage},
    // { path: "/paywall", component: CloverPaywall},
    // { path: "/subpaywall", component: MateChatSubscriptionPaywall},
];